export const formatPhoneNumStart09To9 = (
  inputPhoneNumber: string,
  isIran = false,
): string => {
  const FormattedNumber = inputPhoneNumber.trim().replace(/\s+/g, '');

  if (isIran && FormattedNumber.startsWith('0')) {
    return FormattedNumber.slice(1);
  }

  return FormattedNumber;
};

export default formatPhoneNumStart09To9;

//  a phone number formatter that converts phone numbers with 98 to 0 if the format matches
export const format98To0 = (inputPhoneNumber?: string | null): string => {
  if (!inputPhoneNumber) return '';

  const trimmedValue = inputPhoneNumber.trim();

  if (trimmedValue.length === 12 && trimmedValue.startsWith('98')) {
    return '0' + trimmedValue.slice(2);
  }

  return trimmedValue;
};
